<template>
  <form
    ref="form"
    @submit.prevent="submit"
  >
    <c-title>Zusammenfassung und Erklärungen</c-title>

    <c-form-fieldset
      v-if="reportData"
      class="mt-8 mb-8"
      legend="Zusammenfassung Antragsformular"
    >
      <c-summary-list>
        <c-summary-list-item title="(Titel) Antragssteller:in 1">
          {{ reportData.applicant1_name }}
        </c-summary-list-item>
        <c-summary-list-item title="Funktion">
          {{ reportData.applicant1_function }}
        </c-summary-list-item>
        <c-summary-list-item title="E-Mail-Adresse">
          {{ reportData.applicant1_email }}
        </c-summary-list-item>
        <c-summary-list-item title="Telefonnummer">
          {{ reportData.applicant1_phone }}
        </c-summary-list-item>
        <c-summary-list-item title="(Titel) Antragssteller:in 2">
          {{ reportData.applicant2_name }}
        </c-summary-list-item>
        <c-summary-list-item title="Funktion">
          {{ reportData.applicant2_function }}
        </c-summary-list-item>
        <c-summary-list-item title="E-Mail-Adresse">
          {{ reportData.applicant2_email }}
        </c-summary-list-item>
        <c-summary-list-item title="Telefonnummer">
          {{ reportData.applicant2_phone }}
        </c-summary-list-item>
        <c-summary-list-item title="Hochschule">
          {{ reportData.university }}
        </c-summary-list-item>
        <c-summary-list-item title="Fakultät / Dekanat / Zentrale Einrichtung">
          {{ reportData.faculty }}
        </c-summary-list-item>
        <c-summary-list-item title="Fachbereich / Institut / Department">
          {{ reportData.department }}
        </c-summary-list-item>
        <c-summary-list-item title="Anschrift">
          {{ reportData.address }}
          <br>
          {{ reportData.postal_code }} {{ reportData.city }}
        </c-summary-list-item>
        <c-summary-list-item title="Projekttitel">
          {{ reportData.project_title }}
        </c-summary-list-item>
        <c-summary-list-item title="Zeitraum">
          {{ reportData.event_dates }}
        </c-summary-list-item>
        <c-summary-list-item title="Zielgruppe">
          {{ reportData.target_group }}
        </c-summary-list-item>
        <c-summary-list-item title="Weitere Projektbeteiligte / Kooperationspartner:innen">
          {{ reportData.further_involved }}
        </c-summary-list-item>
        <c-summary-list-item title="Kurzbeschreibung des Projekts">
          {{ reportData.message_text }}
        </c-summary-list-item>
        <c-summary-list-item title="Gesamtkosten">
          {{ reportData.total_cost }}
        </c-summary-list-item>
        <c-summary-list-item title="Anderweitig beantragte und/oder bewilligte Mittel">
          {{ reportData.secured_funds }}
        </c-summary-list-item>
        <c-summary-list-item title="Antragssumme Claussen-Simon-Stiftung">
          {{ reportData.application_amount }}
        </c-summary-list-item>
        <c-summary-list-item title="Projektbeschreibung">
          <div v-if="reportData.project_description.name">
            Datei: {{ reportData.project_description.name }}
          </div>
        </c-summary-list-item>
        <c-summary-list-item title="Kosten- und Finanzierungsplan">
          <div v-if="reportData.cost_plan_file.name">
            Datei: {{ reportData.cost_plan_file.name }}
          </div>
        </c-summary-list-item>
        <c-summary-list-item title="Bedarfsbestätigung des Medien- bzw. Rechenzentrums">
          <div v-if="reportData.media_center_confirmation.name">
            Datei: {{ reportData.media_center_confirmation.name }}
          </div>
        </c-summary-list-item>
      </c-summary-list>
    </c-form-fieldset>

    <c-form-fieldset
      legend="Erklärungen"
      class="mb-8"
    >
      <c-form-checkbox
        v-model="fields.consent_privacy"
        class="mb-5"
        label="Ich erkläre mich mit der Speicherung und Verarbeitung der angegebenen Daten gemäß Art. 6 Abs. 1b) Datenschutz-Grundverordnung (DSGVO) einverstanden und habe <a href='https://www.claussen-simon-stiftung.de/de/stiftung/impressum/' target='_blank'>die Information gemäß Art. 13 DSGVO</a> zur Kenntnis genommen."
        required
      />

      <c-form-checkbox
        v-model="fields.consent_mention"
        class="mb-5"
        label="Ich erkläre mich einverstanden, dass im Falle einer Förderung ggf. die Förderdaten (Name, Thema des geförderten Vorhabens) in Pressemeldungen, Stiftungspublikationen und im Internet veröffentlicht werden."
        required
      />

      <c-form-checkbox
        v-model="fields.consent_publication"
        class="mb-5"
        label="Ich versichere die Richtigkeit und Vollständigkeit der Angaben."
        required
      />
      <c-form-checkbox
        v-model="fields.consent_credit"
        class="mb-5"
        label="Im Falle einer Förderung durch die Claussen-Simon-Stiftung verpflichte ich mich in Verlautbarungen gegenüber der Öffentlichkeit, insbesondere in Veröffentlichungen im Zusammenhang mit dem geförderten Vorhaben, auf die Unterstützung durch den Claussen-Simon-Fonds für Hochschulen der Claussen-Simon-Stiftung hinzuweisen (z.B. in Pressemittteilungen, Platzierungen des Stiftungslogos auf Homepage und Drucksachen etc.) und die Presse- und Marketingaktivitäten mit uns abstimmen."
        required
      />
    </c-form-fieldset>

    <c-form-text
      v-model="fields.signature_and_date"
      :errors="errors.signature_and_date"
      class="mb-8"
      label="Vollständiger Name und Datum"
      help="Dieses Formular wurde digital erstellt und gilt als unterschrieben von:"
      maxlength="400"
      required
    />

    <div
      id="frc-captcha"
      class="mb-8"
    />

    <c-message
      v-if="unhandledError.status"
      type="error"
      class="mb-8"
    >
      <p v-if="unhandledError.message">
        {{ unhandledError.message }}
      </p>

      <template v-else>
        <p class="mb-3">
          Bei der Übertragung des Antrags kam es zu einem Fehler. Bitte probieren Sie es zu einem späteren Zeitpunkt erneut.
        </p>
        <p class="mb-3">
          Prüfen Sie bitte auch, ob die hochgeladenen Dateien zu groß sind. Die maximale Dateigröße beträgt 5 MB.
        </p>
        <p class="mb-3">
          Sollte das Problem weiterhin bestehen, wenden Sie sich mit der folgenden Fehlermeldung an uns:
        </p>
        <p>
          {{ unhandledError.status }} {{ unhandledError.fallback }}
        </p>
      </template>
    </c-message>

    <c-button
      type="button"
      class="mr-5"
      color="secondary"
      @click="previous"
    >
      Zurück
    </c-button>

    <c-button :disabled="(isLoading || !published)">
      Antragsformular abschicken
    </c-button>

    <transition name="fade">
      <c-loading v-if="isLoading" />
    </transition>
  </form>
</template>

<script>
import BRequestStep from './BRequestStep.vue'
import { WidgetInstance } from 'friendly-challenge'

import CLoading from '../components/CLoading.vue'
import CMessage from '../components/CMessage.vue'
import CSummaryList from '../components/CSummaryList.vue'
import CSummaryListItem from '../components/CSummaryListItem.vue'

import { postRequest } from '../api.js'
import { FRIENDLY_CAPTCHA_SITEKEY } from '../settings.js'
import CFormCheckbox from '../components/CFormCheckbox.vue'

export default {
  name: 'VRequestStep1',

  components: {
    CLoading,
    CMessage,
    CSummaryList,
    CSummaryListItem,
    CFormCheckbox
  },

  extends: BRequestStep,

  data () {
    return {
      isLoading: false,
      widget: null,
      unhandledError: {
        status: null,
        message: '',
        fallback: ''
      },
      fields: {
        consent_privacy: false,
        consent_publication: false,
        consent_mention: false,
        consent_credit: false,
        signature_and_date: '',
        frc_captcha_solution: ''
      }
    }
  },

  computed: {
    step: () => 1,
    id: () => 'summaryTerms',
    steps () {
      return this.$store.state.steps
    },
    reportData () {
      return this.steps[0]?.fields
    },
    salutation () {
      return {
        f: 'Frau',
        m: 'Herr',
        n: false
      }[this.reportData.salutation]
    },
    published () {
      return this.$store.state.publishedInfo.published
    },
    focalSupport () {
      const supportList = []
      if (this.reportData.democracy_education) {
        supportList.push('Demokratiebildung')
      }
      if (this.reportData.personality_development) {
        supportList.push('Persönlichkeitsentwicklung')
      }
      if (this.reportData.vocational_training) {
        supportList.push('berufliche Bildung & Übergänge')
      }

      const supportString = supportList.join(', ')

      return supportString
    }
  },

  mounted () {
    const el = document.querySelector('#frc-captcha')
    this.widget = new WidgetInstance(el, {
      startMode: 'auto',
      sitekey: FRIENDLY_CAPTCHA_SITEKEY,
      doneCallback: (solution) => {
        this.fields.frc_captcha_solution = solution
      },
      errorCallback: () => {
        this.fields.frc_captcha_solution = 'linter boy'
      }
    })
  },

  beforeDestroy () {
    if (this.widget) {
      this.widget.destroy()
    }
  },

  methods: {
    formatTextarea (text) {
      return text
        .split('\n\n')
        .map(p => `<p class="mb-3">${p}</p>`)
        .join('')
        .split('\n')
        .join('<br>')
    },
    async submit () {
      this.isLoading = true
      this.unhandledError.status = null
      this.unhandledError.message = ''
      this.unhandledError.fallback = ''

      this.save({ completed: true })

      const form = new FormData()

      for (const step of this.steps) {
        for (const field in step.fields) {
          form.append(field, step.fields[field])
        }
      }

      if (
        this.fields.consent_privacy &&
        this.fields.consent_publication &&
        this.fields.consent_mention
      ) {
        form.append('has_accepted_conditions', true)
      } else {
        this.unhandledError.status = 10
        this.unhandledError.fallback = 'Bitte akzeptieren Sie alle Erklärungen.'
        this.isLoading = false
        return
      }

      if (!this.fields.frc_captcha_solution) {
        this.unhandledError.status = 11
        this.unhandledError.fallback = 'Bitte lösen Sie das Captcha.'
        this.isLoading = false
        return
      }

      try {
        await postRequest(form)
        this.$router.push({ name: 'thank-you' })
        this.$store.commit('reset')
      } catch (error) {
        const response = error.response

        if (response.headers['content-type'] === 'application/json') {
          this.$store.commit('errors', response.data)
          this.$router.push({ name: 'request-step-0' })
          return
        }

        const message = {
          413: 'Ihre hochgeladenen Dateien sind zu groß. Bitte wählen Sie kleinere Dateien aus und probieren es erneut.'
        }[response?.status]

        if (message) {
          this.unhandledError.message = message
        } else {
          this.unhandledError.fallback = response?.statusText ?? error.message
        }

        this.unhandledError.status = response?.status ?? error.name
        this.isLoading = false
      }
    }
  }
}
</script>
